import { render } from "./KeyHighlight.vue?vue&type=template&id=0054f582"
import script from "./KeyHighlight.vue?vue&type=script&lang=js"
export * from "./KeyHighlight.vue?vue&type=script&lang=js"

import "./KeyHighlight.vue?vue&type=style&index=0&id=0054f582&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__